import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { API, ReportingFullDTO } from '../../../../services/api/api';
import { UtilService } from '../../../../services/util.service';
import { PermissionService } from '../../../../services/permission.service';
import { StringTransformationService } from '../../../../services/transformation-helper/string-transformation.service';
import { SearchOptions } from '@ngx-seatback/controls';
import { FilterPanelConfig } from '@ngx-seatback/layout';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RequestClass } from '../../../../services/global/RequestClass';

@Component({
  selector: 'sb-page-generated-reports',
  templateUrl: './generated-reports.component.html',
  styleUrls: ['./generated-reports.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneratedReportsComponent extends RequestClass {
  public readonly api = inject(API);
  public readonly util = inject(UtilService);
  public readonly permissionService = inject(PermissionService);
  private readonly stringTransformation = inject(StringTransformationService);
  private readonly destroyRef = inject(DestroyRef);

  // table wrapper variables
  reports: ReportingFullDTO[] = [];

  // filter variables
  exactMatch: SearchOptions = 'contains';
  search: string | null = null;
  filterConfig: FilterPanelConfig = {
    showExactMatch: true,
    showSearchHeadline: true,
    hideTagSection: true,
    button: { visibleWithoutChanges: true },
  };

  /*
  showReport(reporting_id: number): void {
      if (reporting_id) {
          let string = new StringDTO();
          string.string = template.default;
          this.api.shared_Reporting_renderByIdWithFTL(reporting_id, string).subscribe((data) => {
              console.log(data);
          });
      }
  }
*/

  refreshFromServer() {
    if (!this.pagination) {
      this.loading.set(false);
      return;
    }
    this.loading.set(true);
    const sub = this.api
      .shared_Reporting_retrieveAll(
        {
          search: this.stringTransformation.encodeSearchQueryParamWithOptions(this.exactMatch, this.search),
        },
        this.pagination
      )
      .pipe(
        take(1),
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.loading.set(false);
        })
      )
      .subscribe((reports: ReportingFullDTO[]) => {
        this.reports = reports;
      });
    this.subs.push(sub);
  }

  /* TODO implement when Backend functionality is provided
getReport(rep: ReportingDTO) {
rep = rep;
this.api.shared_Reporting_getGeneratedReport(rep.id).subscribe((res: string) => {
  console.log(res);
});
}
 */

  applyFiltering(filterMap: Map<string, any[]>) {
    this.setRequestOptions(filterMap);
    this.requestDebounced();
  }

  setRequestOptions(filterMap: Map<string, any[]>) {
    this.search = filterMap.get('search')?.[0];
    this.exactMatch = filterMap.get('exactMatch')?.[0];
  }
}
